import { Box } from "@mantine/core";
import { Header } from "@tanstack/react-table";

import { SortDownIcon, SortIcon, SortUpIcon } from "../../../assets/icons";

import styles from "./Sorting.module.scss";

export const Sorting = ({ header, children }: { header: Header<any, unknown>; children: React.ReactNode }) => {
    if (header.isPlaceholder || !header.column.getCanSort()) {
        return <div className={styles.placeholder}>{children}</div>;
    }

    const sortDirection = header.column.getIsSorted();

    return (
        <Box role="button" className={styles["sort-button"]} onClick={header.column.getToggleSortingHandler()}>
            {children}
            <div className={styles["sort-icons"]}>
                {!sortDirection && <SortIcon />}
                {sortDirection === "asc" && <SortUpIcon />}
                {sortDirection === "desc" && <SortDownIcon />}
            </div>
        </Box>
    );
};
